import React from "react";
import { useSelector } from "react-redux";
import { useGetTodosQuery } from "../features/api/apiSlice";
import Filter from "./Filter";

const Footer = () => {
  const filter = useSelector((state) => state.filter);
  const { data: todos, isSuccess } = useGetTodosQuery(filter);
  let incompleteTask = [];

  if (isSuccess) {
    incompleteTask = todos?.filter((todo) => !todo.completed);
  }

  return (
    <div className='mt-4 flex justify-between text-xs text-gray-500'>
      <p>
        {`${incompleteTask?.length > 0 ? incompleteTask?.length : "No"} task${
          incompleteTask?.length > 1 ? "s" : ""
        } left`}{" "}
      </p>
      <Filter />
    </div>
  );
};

export default Footer;
